import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
} from '../../utils/event_constants';

export const typesenseSearchActions = [
  {
    name: 'reindexDataForTypesenseCollection',
    label: 'Re Index Data for Typesense Collection',
    args: [
      {
        name: 'typesenseCollection',
        label: 'Select Typesense Collection',
        type: 'dropdown',
        optionsType: 'typesenseSearchCollectionApi',
        options: [],
        value: '',
      },
      {
        name: 'reIndexOnTheBasisOfTenant',
        label: 'Reindex Data for Logged-in Tenant',
        type: 'boolean',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'deleteTypesenseCollection',
    label: 'Delete Typesense Collection',
    args: [
      {
        name: 'typesenseCollection',
        label: 'Select Typesense Collection',
        type: 'dropdown',
        optionsType: 'typesenseSearchCollectionApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'queryFromTypesense',
    label: 'Get Data From Typesense',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForQuery', label: 'Select Query Field' }),
      collectionFieldArgsConfig({ name: 'fieldForContext', label: 'Select Context Field' }),
      {
        name: 'collectionOfTypesense',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
        multi: true,
      },
      ...alertMessagesArgsConfig,
    ],
  },
];
